/** Locale-aware EUR formatting (German: "20,00 €", English: "€20.00"). */
export const formatEur = (amount: number, lang?: string) =>
  new Intl.NumberFormat(lang?.startsWith('en') ? 'en-IE' : 'de-DE', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
